import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

//styles
import classes from './modal.module.css';

//icons
import { FiX } from 'react-icons/fi';
import { Loader } from '../../../components';


function ComfirmModal({plan, amount, coin, close, deposit}) {
    //redux state
    const depositLoading = useSelector(state => state.mainReducer.depositLoading);
    const depositModal = useSelector(state => state.mainReducer.depositModal);

    useEffect(() => {
        if(depositModal){
            close()
        }
    }, [depositModal])

    const Item = ({title, details}) => {
        return(
            <div className={classes.Item}>
                <div className={classes.details_title}>{title}</div>
                <div className={classes.details_main}>{details}</div>
            </div>
        )
    };
    

    let wallet;
    if(coin === 'Binance coin'){
        wallet = 'Binance - 0x0Cf778dcAcbFD691f070782a1F7Df7Db8e4A0FF9';
    }else if(coin === 'Ethereum'){
        wallet = 'Eth - 0x0Cf778dcAcbFD691f070782a1F7Df7Db8e4A0FF9'
    }else if(coin === 'Litecoin'){
        wallet = 'Litecoin - ltc1qz4484hxp62p6vvygrr4uatcsd8mrj93muxa4s0'
    }else if(coin === 'Payeer'){
        wallet = 'Payeer - P1105731032'
    }else if(coin === 'BUSD (bep20)'){
        wallet = 'BUSD (bep20) - 0x0Cf778dcAcbFD691f070782a1F7Df7Db8e4A0FF9'
    }else if(coin === 'USDT TRC20'){
        wallet = 'USDT TRC20 - TPZQdJU7cHhuRdGk3k4QXtATanRfuGAJSz'
    }else if(coin === 'Tron (trx)'){
        wallet = 'Tron (trx) - TPZQdJU7cHhuRdGk3k4QXtATanRfuGAJSz'
    }else if(coin === 'Binance usdt(bep2)'){
        wallet = 'Binance usdt(bep2) - 0x0Cf778dcAcbFD691f070782a1F7Df7Db8e4A0FF9'
    }else if(coin === 'Balance'){
        wallet = 'Deposit will be deducted from account balance'
    }else{
        wallet = 'Btc - 1GF9bFgReFuGQx8BQaKH7N3gELJMWFYWgn'
    }

    let profit;

    if(plan === 'Starter'){
        profit = '7% after 24 hours'
    }else if(plan === 'Basic'){
        profit = '10% after 24 hours'
    }else if(plan === 'Silver'){
        profit = '20% after 16 hours'
    }else if(plan === 'Advanced'){
        profit = '50% after 24 hours'
    }else{
        profit = '100% after 48 hours'
    }

    let container = (
        <div>
            <div className={classes.backdrop_close} onClick={close}> <FiX /> </div>
            <div className={classes.top}>Confirm Deposit</div>
            {coin === 'Balance' ? <div className={classes.intro}><span>{wallet}</span></div> : <div className={classes.intro}>Make deposit into company's wallet address: <span>{wallet}</span></div>}
            <div className={classes.details}>
                <Item title={'Plan'} details={plan} />
                <Item title={'Profit'} details={profit} />
                <Item title={'Principal Return'} details={'Yes'} />
                <Item title={'Instant Withdraw'} details={'Availiable'} />
                <Item title={'Credit Amount'} details={`$${amount.toLocaleString()}`} />
                <Item title={'Deposit Fee'} details={'0.00% + $0.00 (min. $0.00 max. $0.00)'} />
            </div>
            <button onClick={deposit} >Confirm Deposit</button>
        </div>
    )

    return (
        <div className={classes.backdrop}>
            <div className={classes.backdrop_main}>
                {depositLoading ? <Loader /> : container }
            </div>
        </div>
    )
}

export default ComfirmModal